import { graphql } from '@/gql';
import type { AcceptSpecialOfferMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const acceptSpecialOffer = async (variables: AcceptSpecialOfferMutationVariables) => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation AcceptSpecialOffer($code: String!, $nextPlanName: String, $phoneNumber: String!, $promoCode: String, $reason: String!) {
        acceptSpecialOffer(code: $code, nextPlanName: $nextPlanName, phoneNumber: $phoneNumber, promoCode: $promoCode, reason: $reason)
      }
    `),
    variables,
  });

  return response.data?.acceptSpecialOffer;
};
